import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaCodeBranch, FaFileAlt } from 'react-icons/fa';
import contributions from '../data/contributions';
import './Contributions.css';

const REPO_URL = 'https://github.com/Bat0oo/open-source-contributions';

// The portfolio shows only the newest few; the full list lives in the repo (button below).
const MAX_SHOWN = 3;

// Newest first; merged before open/closed within the same month.
const STATUS_ORDER = { merged: 0, open: 1, closed: 2 };
const sorted = [...contributions]
  .sort((a, b) => b.date.localeCompare(a.date) || STATUS_ORDER[a.status] - STATUS_ORDER[b.status])
  .slice(0, MAX_SHOWN);

const Contributions = ({ t, language }) => {
  // Render nothing until the first contribution exists.
  if (sorted.length === 0) return null;

  const c = t.contributions;

  return (
    <section className="contributions" id="contributions">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title neon-text">
            <FaCodeBranch className="contrib-title-icon" /> {c.title}
          </h2>
          <p className="projects-subtitle">{c.subtitle}</p>

          <ul className="contrib-list">
            {sorted.map((item, index) => (
              <motion.li
                key={item.id}
                className="contrib-row neon-border"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.08 }}
                viewport={{ once: true }}
              >
                <div className="contrib-main">
                  <div className="contrib-meta">
                    <span className={`contrib-type type-${item.type}`}>{item.type}</span>
                    <a
                      className="contrib-project"
                      href={item.project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.project.name}
                    </a>
                    <span className="contrib-date">{item.date}</span>
                  </div>

                  <a
                    className="contrib-title"
                    href={item.pr}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.title}
                  </a>

                  {item.summary && (
                    <p className="contrib-summary">{item.summary[language]}</p>
                  )}

                  <div className="contrib-stack">
                    {item.stack.map((s) => (
                      <span key={s} className="tech-badge">{s}</span>
                    ))}
                  </div>
                </div>

                <div className="contrib-side">
                  <span className={`contrib-status status-${item.status}`}>
                    {c.statuses[item.status]}
                  </span>
                  <a
                    className="contrib-link"
                    href={item.pr}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaGithub /> PR
                  </a>
                  {item.writeup && (
                    <a
                      className="contrib-link"
                      href={item.writeup}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFileAlt /> {c.details}
                    </a>
                  )}
                </div>
              </motion.li>
            ))}
          </ul>

          <div className="contrib-footer">
            <a className="neon-button" href={REPO_URL} target="_blank" rel="noopener noreferrer">
              <FaGithub /> {c.viewRepo}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contributions;
